import { CONTRACT_JOURNEY_APP_IDS } from '../contractAppIds';
import Check from '@mui/icons-material/Check';
import InfoOutlined from '@mui/icons-material/InfoOutlined';
import { Box, Card, Typography } from '@mui/material';
import JourneyAppPromo from '~/components/StandardJourney/JourneyAppPromo';
import { blue, neutral } from '~/styles/tokens/primitives.colors';
import { radius } from '~/styles/tokens/shape';

export default function ContractCompletedView() {
  return (
    <Box
      data-app-id={CONTRACT_JOURNEY_APP_IDS.completed}
      sx={{ display: 'flex', flexDirection: 'column', gap: { md: 8, xs: 4 }, mx: 'auto', maxWidth: 699, width: '100%' }}
    >
      <Card
        data-app-id={`${CONTRACT_JOURNEY_APP_IDS.completed}-success-card`}
        elevation={0}
        sx={{
          alignItems: 'center',
          borderRadius: `${radius.large}px`,
          boxShadow: '0px 1px 1px rgba(0,0,0,0.3), 0px 2px 3px rgba(0,0,0,0.15)',
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
          p: 3,
          textAlign: 'center'
        }}
      >
        <Box
          sx={{
            alignItems: 'center',
            bgcolor: 'success.main',
            borderRadius: '100px',
            color: 'common.white',
            display: 'flex',
            height: 64,
            justifyContent: 'center',
            width: 64
          }}
        >
          <Check aria-hidden sx={{ fontSize: 32 }} />
        </Box>
        <Typography data-app-id={`${CONTRACT_JOURNEY_APP_IDS.completed}-title`} variant="h5">
          Contratação concluída com sucesso!
        </Typography>
        <Typography data-app-id={`${CONTRACT_JOURNEY_APP_IDS.completed}-subtitle`} variant="subtitle1">
          Seu pagamento foi aprovado e o contrato está sendo analisado pela seguradora. Em breve você receberá a
          confirmação no seu e-mail.
        </Typography>
        <Box
          data-app-id={`${CONTRACT_JOURNEY_APP_IDS.completed}-info`}
          sx={{
            alignItems: 'flex-start',
            bgcolor: blue[100],
            borderRadius: `${radius.medium}px`,
            display: 'flex',
            gap: 2,
            p: 2,
            textAlign: 'left',
            width: '100%'
          }}
        >
          <InfoOutlined aria-hidden sx={{ color: neutral[1100], flexShrink: 0, mt: 0.25 }} />
          <Typography sx={{ color: neutral[1100] }} variant="body1">
            A análise é feita em até 15 dias úteis. Reforçamos a cobertura completa do seguro e seus benefícios durante
            o período de análise.
          </Typography>
        </Box>
      </Card>

      <JourneyAppPromo appId={CONTRACT_JOURNEY_APP_IDS.completed} />
    </Box>
  );
}
